/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_No_Ups_ReadyInputs */

const en_orders_no_ups_ready = /** @type {(inputs: Orders_No_Ups_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No UPS-ready orders selected`)
};

const es_orders_no_ups_ready = /** @type {(inputs: Orders_No_Ups_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay pedidos listos para UPS seleccionados`)
};

/**
* | output |
* | --- |
* | "No UPS-ready orders selected" |
*
* @param {Orders_No_Ups_ReadyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_ups_ready = /** @type {((inputs?: Orders_No_Ups_ReadyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_Ups_ReadyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_ups_ready(inputs)
	return es_orders_no_ups_ready(inputs)
});